import { Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { roleLabel } from '../../engine/engine-case.mapper';
import { AuditTrailView } from '../../models/audit-trail-view';

@Component({
  selector: 'app-workflow-audit-trail',
  imports: [DatePipe],
  templateUrl: './workflow-audit-trail.component.html',
  styleUrl: './workflow-audit-trail.component.scss',
})
export class WorkflowAuditTrailComponent {
  trail = input.required<AuditTrailView>();
  readonly roleLabel = roleLabel;
}